// A constraint prompt may carry several ';'-separated phrases, spoken one per ask.
export const PROMPT_PHRASE_SEPARATOR = ';';

export const splitPromptPhrases = (prompt?: string | null): string[] =>
  (prompt ?? '')
    .split(PROMPT_PHRASE_SEPARATOR)
    .map((phrase) => phrase.trim())
    .filter((phrase) => phrase.length);

// The phrase for this ask, as the AI's re-ask ladder speaks it: each phrase once, then the first from the checkpoint on.
export const pickPromptPhrase = (
  phrases: string[],
  askIndex = 0
): string | undefined =>
  phrases.length
    ? phrases[askIndex < phrases.length ? askIndex : 0]
    : undefined;
